import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { fetchCreateCpdDraft, TCreateCpdDraftResponse } from 'shared/repositories/cpd/v1/create-cpd-draft';
import { selectOfferId } from 'shared/selectors';
import { IThunkActionCreator } from 'shared/store';

import { setCpdDraftId, setCpdDraftStatus } from './';
import { ECpdDraftStatus } from '../../types/cpd/cpd';

export const createDraftCpd = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  try {
    const state = getState();
    const offerId = selectOfferId(state);
    const resCpdDraft = (await fetchCreateCpdDraft({
      httpApi: context.httpApi,
      parameters: {
        offerId,
        source: 'homeownerOffer',
      },
    })) as TCreateCpdDraftResponse;

    dispatch(setCpdDraftStatus(ECpdDraftStatus.loading));

    if (resCpdDraft.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: resCpdDraft.statusCode,
        domain: 'createDraftCpd.ts',
        message: resCpdDraft.response.message as string,
      });
    }

    const { cpdDraftId } = resCpdDraft.response;

    dispatch(setCpdDraftId(cpdDraftId));
    dispatch(setCpdDraftStatus(ECpdDraftStatus.success));
  } catch (e) {
    context.logger.error(e);

    dispatch(setCpdDraftStatus(ECpdDraftStatus.fail));
  }
};
